export function getJWTPayload(token: string) {
  const parts = token.split('.')
  const payload = parts[1]

  const decodeStr = process.client ? atob : require('atob')
  const decodedToken = JSON.parse(decodeStr(payload))

  return decodedToken
}
